import React, { useContext } from 'react';
import { map } from 'lodash';
import { BaseContext } from '../../../contexts';
import PlansListStatistics from '../../../components/plansListStatistics';

const Plans = ({ onBack, onSelect }) => {
  const { plans, addElementToScrollablePlan } = useContext(BaseContext);
  const handleOnSelect = (plan) => () => {
    onSelect(plan);
  };
  return (
    <PlansListStatistics>
      <div className="subscriptions white">
        <header className="sticky-header">
          <button className="back-button" onClick={ onBack }>
            <span className="dash" />
            More plans
          </button>
        </header>
        <div className="subscriptions-main">
          <h3>Select the Cloud plan that’s right for you.</h3>
          {
            map(plans, (plan) => (
              <div key={ plan.id } className="subscription-image-card">
                <div className="card-content">
                  <div className="title-plate">
                    <h4 ref={ addElementToScrollablePlan(plan) }>{ plan.title }</h4>
                    <p className="price">{ plan.price }</p>
                  </div>
                  { plan.description }
                  <button className="button select-button" onClick={ handleOnSelect(plan) }>
                    Select
                  </button>
                </div>
              </div>
            ))
          }
          <div className="asterisk-note">
            * Plus taxes and Verizon surcharges. Your Cloud plan will auto-renew at the monthly
            { ' ' }
            charge until you cancel. Cancel anytime in Verizon Cloud app.
          </div>
          <div className="plans-bottom">
            <button className="button alt-button">Log in to other account</button>
          </div>
        </div>
      </div>
    </PlansListStatistics>
  );
};

export default Plans;
